// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2rCao","choiceBoxes":"toolbarselects_choiceBoxes__157V0","simpleField":"toolbarselects_simpleField__2tBBm"};